window.__mafPendoBridgeLoaded = true;
console.log("✓ pendoDonationBridge loaded");

/* pendoDonationBridge.js */
(function () {
  "use strict";

  // Mark loaded (helps you debug)
  window.__mafPendoBridgeLoaded = true;

  // --- Config ---
  var DEBUG = false; // set true temporarily
  var FLUSH_INTERVAL_MS = 1000;  // how often we try to flush queued events to Pendo
  var POLL_INTERVAL_MS = 500;    // fallback: watch dataLayer length changes

  // --- Helpers ---
  function log() {
    if (DEBUG && window.console && console.log) {
      console.log.apply(console, arguments);
    }
  }

  function hasPendo() {
    return !!(window.pendo && typeof window.pendo.track === "function");
  }

  function mapEventName(dlEventName) {
    switch (dlEventName) {
      case "donation_step_view": return "donation_step_view";
      case "donation_modal_close": return "donation_modal_close";
      case "add_to_cart": return "donation_add_to_cart";
      case "begin_checkout": return "donation_begin_checkout";
      case "purchase": return "donation_purchase";
      default: return null;
    }
  }

  // IMPORTANT: avoid PII (email/phone/name/address) here
  function buildProps(obj) {
    var ecommerce = obj.ecommerce || {};
    var firstItem = (ecommerce.items && ecommerce.items[0]) ? ecommerce.items[0] : {};

    return {
      donation_flow: obj.donation_flow,
      donation_only: obj.donation_only,
      donation_session_id: obj.donation_session_id,

      donation_step: obj.donation_step,
      donation_step_index: obj.donation_step_index,
      donation_type: obj.donation_type,

      value: obj.value || ecommerce.value || null,
      currency: ecommerce.currency || obj.currency || "USD",

      close_reason: obj.close_reason,

      item_id: obj.item_id || firstItem.item_id,
      item_name: obj.item_name || firstItem.item_name,

      transaction_id: ecommerce.transaction_id || obj.transaction_id
    };
  }

  // Dedupe to prevent double-counting if events fire twice
  var sent = Object.create(null);
  function dedupeKey(eventName, props) {
    return [
      eventName,
      props.donation_session_id || "",
      props.donation_step || "",
      props.donation_step_index || "",
      props.close_reason || "",
      props.transaction_id || "",
      props.item_id || "",
      props.value || ""
    ].join("|");
  }

  // Queue if Pendo isn't ready yet
  var queue = [];
  function enqueue(pendoEvent, props) {
    queue.push({ name: pendoEvent, props: props });
    log("[PendoBridge] queued", pendoEvent, props);
  }

  function flushQueue() {
    if (!hasPendo() || queue.length === 0) return;

    // flush safely
    try {
      while (queue.length) {
        var item = queue.shift();
        window.pendo.track(item.name, item.props);
        log("[PendoBridge] sent", item.name, item.props);
      }
    } catch (e) {
      // if something weird happens, don't crash; re-queue remaining?
      log("[PendoBridge] flush error", e);
    }
  }

  // Track one datalayer object safely
  function handleDLObject(obj) {
    try {
      if (!obj || !obj.event) return;

      var pendoEvent = mapEventName(obj.event);
      if (!pendoEvent) return;

      var props = buildProps(obj);
      var key = dedupeKey(pendoEvent, props);
      if (sent[key]) return;

      sent[key] = true;

      if (hasPendo()) {
        window.pendo.track(pendoEvent, props);
        log("[PendoBridge] sent", pendoEvent, props);
      } else {
        enqueue(pendoEvent, props);
      }
    } catch (e) {
      // never break the site
      log("[PendoBridge] handle error", e);
    }
  }

  // --- dataLayer interception (primary) ---
  window.dataLayer = window.dataLayer || [];

  // Replay anything that already exists (in case pushes happened before this file loaded)
  try {
    for (var i = 0; i < window.dataLayer.length; i++) {
      handleDLObject(window.dataLayer[i]);
    }
  } catch (e) {}

  // Intercept push
  var originalPush = window.dataLayer.push;
  if (!window.__mafPendoPushHooked) {
    window.__mafPendoPushHooked = true;

    window.dataLayer.push = function () {
      try {
        for (var i = 0; i < arguments.length; i++) {
          handleDLObject(arguments[i]);
        }
      } catch (e) {}
      return originalPush.apply(window.dataLayer, arguments);
    };

    log("[PendoBridge] dataLayer.push hooked");
  }

  // --- fallback polling (if someone replaces dataLayer or overrides push later) ---
  var lastLen = window.dataLayer.length;
  setInterval(function () {
    try {
      if (!window.dataLayer || !window.dataLayer.length) return;

      // If dataLayer got replaced, restore hook
      if (window.dataLayer.push !== originalPush && !window.__mafPendoPushHooked) {
        // (rare) but keep simple: do nothing; your app would need a stronger re-hook strategy
      }

      if (window.dataLayer.length > lastLen) {
        for (var i = lastLen; i < window.dataLayer.length; i++) {
          handleDLObject(window.dataLayer[i]);
        }
        lastLen = window.dataLayer.length;
      }
    } catch (e) {}
  }, POLL_INTERVAL_MS);

  // --- flush loop (to catch Pendo becoming ready later) ---
  setInterval(flushQueue, FLUSH_INTERVAL_MS);

  // optional: try an early flush soon after load
  setTimeout(flushQueue, 50);
  setTimeout(flushQueue, 500);

})();